import { render } from "./CollectInfoSettingsView.vue?vue&type=template&id=2e39a777"
import script from "./CollectInfoSettingsView.vue?vue&type=script&lang=js"
export * from "./CollectInfoSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__